<button mat-button class="dark-button">Emoji Selector</button>
